/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "../../assets/style/Fonction.css";
import Filters from "./Filters";
import { AnimatePresence, motion } from "framer-motion";
import { FaArrowRight, FaGithub, FaGlobe, FaPlayCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import projetlaravel from "../../assets/img/laravelreact.png";
import projetspring from "../../assets/img/springbootreact.png";
import mobile from "../../assets/img/mobiles.png";
import uxui from "../../assets/img/uxui.png";
import portfolio from "../../assets/img/portfolio.png";
import innova from "../../assets/img/innova.png";
import twenitsite from "../../assets/img/twenitsite.png";
import marmara from "../../assets/img/marmaraspra.png";
import mobile2 from "../../assets/img/mobiles2.png";
import mobile3 from "../../assets/img/mybb.png";
import mybaby from "../../assets/video/mybaby.mp4";
import marmaraspra from "../../assets/video/marmara_spra.mp4";

const Fonction: React.FC = () => {
  const [filtered, setFiltered] = useState("all");
  const { t } = useTranslation("fr", { useSuspense: false });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<string>("");

  const handleDemoClick = (video: string) => {
    setCurrentVideo(video);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleFilterChange = (filter: string) => {
    setFiltered(filter);
  };

  const projects = [
    {
      title: "titleProject7",
      img: marmara,
      video: marmaraspra,
      category: "app",
      link: "https://play.google.com/store/apps/details?id=com.marmara.spra&pcampaignid=web_share",
    },
    {
      title: "titleProject6",
      img: twenitsite,
      video: "",
      category: "web",
      link: "https://twenit.net",
    },
    {
      title: "titleProject1",
      img: projetlaravel,
      video: "",
      category: "app",
      link: "#",
    },
    {
      title: "titleProject2",
      img: innova,
      video: "",
      category: "web",
      link: "#",
    },
    {
      title: "titleProject5",
      img: mobile,
      video: "",
      category: "app",
      link: "#",
    },
    {
      title: "titleProject3",
      img: projetspring,
      video: "",
      category: "app",
      link: "#",
    },
    {
      title: "titleProject9",
      img: mobile3,
      video: mybaby,
      category: "app",
      link: "https://play.google.com/store/apps/details?id=com.mybaby.mg&pcampaignid=web_share",
    },
    {
      title: "Design Image 3D",
      img: uxui,
      video: "",
      category: "design",
      link: "#",
    },
    {
      title: "titleProject4",
      img: portfolio,
      video: "",
      category: "web",
      link: "#",
    },
    {
      title: "titleProject8",
      img: mobile2,
      video: "",
      category: "app",
      link: "#",
    },
  ];

  return (
    <div>
      <section className="work section" id="work">
        <div className="contenu">
          <Filters setFiltered={handleFilterChange} />
          <AnimatePresence>
            <div className="work__container container grid">
              {isModalOpen && (
                <div className="modal-overlay">
                  <div className="modal">
                    <button className="modal-close" onClick={closeModal}>
                      ✕
                    </button>
                    <div className="modal-content">
                      <video width="100%" controls>
                        <source src={currentVideo} type="video/mp4" />
                        Votre navigateur ne supporte pas la vidéo.
                      </video>
                    </div>
                  </div>
                </div>
              )}

              {projects.map(
                (project, index) =>
                  (filtered === "all" || filtered === project.category) && (
                    <motion.div
                      key={index}
                      layout
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      initial={{ opacity: 0 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                      className={`work__card mix ${project.category} ${
                        filtered === "all" || filtered === project.category
                          ? ""
                          : "hidden"
                      }`}
                    >
                      <img
                        src={project.img}
                        alt={project.title}
                        className="work__image"
                      />
                      <h3 className="work__title">{t(project.title)}</h3>
                      <span className="work__button">
                        Demo
                        <FaArrowRight className="work__button-icon" />
                        <>
                          <a
                            href="https://github.com/Ravaka15"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaGithub className="work__github-icon" />
                          </a>
                          <a
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaGlobe className="work__github-icon" />
                          </a>

                          {project.video && (
                            <p onClick={() => handleDemoClick(project.video)}>
                              <FaPlayCircle className="work__github-icon" />
                            </p>
                          )}
                        </>
                      </span>
                    </motion.div>
                  )
              )}
            </div>
          </AnimatePresence>
        </div>
      </section>
    </div>
  );
};

export default Fonction;
